import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'mwe-icon-info-box',
  templateUrl: './icon-info-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconInfoBoxComponent {
  boxTitle = input<string>();
  info = input<string>();
  color = input<'green' | 'yellow'>('green');

  divColorCss = computed(() => {
    switch (this.color()) {
      case 'yellow':
        return 'bg-warning-100';
      case 'green':
      default:
        return 'bg-green-100';
    }
  });

  iconColorCss = computed(() => {
    switch (this.color()) {
      case 'yellow':
        return 'bg-warning';
      case 'green':
      default:
        return 'bg--green';
    }
  });
}
